// source: dash/v1/lesson_unit_book.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var dash_v1_models_pb = require('../../dash/v1/models_pb.js');
goog.object.extend(proto, dash_v1_models_pb);
var types_v1_status_pb = require('../../types/v1/status_pb.js');
goog.object.extend(proto, types_v1_status_pb);
goog.exportSymbol('proto.dash.v1.GetLessonUnitBookRequest', null, global);
goog.exportSymbol('proto.dash.v1.GetLessonUnitBookResponse', null, global);
goog.exportSymbol('proto.dash.v1.ListLessonUnitBooksRequest', null, global);
goog.exportSymbol('proto.dash.v1.ListLessonUnitBooksResponse', null, global);
goog.exportSymbol('proto.dash.v1.PutLessonUnitBookRequest', null, global);
goog.exportSymbol('proto.dash.v1.PutLessonUnitBookRequest.ContentCase', null, global);
goog.exportSymbol('proto.dash.v1.PutLessonUnitBookResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.GetLessonUnitBookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.GetLessonUnitBookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.GetLessonUnitBookRequest.displayName = 'proto.dash.v1.GetLessonUnitBookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.GetLessonUnitBookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.GetLessonUnitBookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.GetLessonUnitBookResponse.displayName = 'proto.dash.v1.GetLessonUnitBookResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.PutLessonUnitBookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.dash.v1.PutLessonUnitBookRequest.oneofGroups_);
};
goog.inherits(proto.dash.v1.PutLessonUnitBookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.PutLessonUnitBookRequest.displayName = 'proto.dash.v1.PutLessonUnitBookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.PutLessonUnitBookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.PutLessonUnitBookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.PutLessonUnitBookResponse.displayName = 'proto.dash.v1.PutLessonUnitBookResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.ListLessonUnitBooksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.ListLessonUnitBooksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.ListLessonUnitBooksRequest.displayName = 'proto.dash.v1.ListLessonUnitBooksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.ListLessonUnitBooksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dash.v1.ListLessonUnitBooksResponse.repeatedFields_, null);
};
goog.inherits(proto.dash.v1.ListLessonUnitBooksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.ListLessonUnitBooksResponse.displayName = 'proto.dash.v1.ListLessonUnitBooksResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.GetLessonUnitBookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.GetLessonUnitBookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.GetLessonUnitBookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitBookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.GetLessonUnitBookRequest}
 */
proto.dash.v1.GetLessonUnitBookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.GetLessonUnitBookRequest;
  return proto.dash.v1.GetLessonUnitBookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.GetLessonUnitBookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.GetLessonUnitBookRequest}
 */
proto.dash.v1.GetLessonUnitBookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.GetLessonUnitBookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.GetLessonUnitBookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.GetLessonUnitBookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitBookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.dash.v1.GetLessonUnitBookRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.v1.GetLessonUnitBookRequest} returns this
 */
proto.dash.v1.GetLessonUnitBookRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.GetLessonUnitBookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.GetLessonUnitBookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.GetLessonUnitBookResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitBookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnitBook: (f = msg.getLessonUnitBook()) && dash_v1_models_pb.LessonUnitBook.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.GetLessonUnitBookResponse}
 */
proto.dash.v1.GetLessonUnitBookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.GetLessonUnitBookResponse;
  return proto.dash.v1.GetLessonUnitBookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.GetLessonUnitBookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.GetLessonUnitBookResponse}
 */
proto.dash.v1.GetLessonUnitBookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnitBook;
      reader.readMessage(value,dash_v1_models_pb.LessonUnitBook.deserializeBinaryFromReader);
      msg.setLessonUnitBook(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.GetLessonUnitBookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.GetLessonUnitBookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.GetLessonUnitBookResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitBookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnitBook();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnitBook.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonUnitBook lesson_unit_book = 1;
 * @return {?proto.dash.v1.LessonUnitBook}
 */
proto.dash.v1.GetLessonUnitBookResponse.prototype.getLessonUnitBook = function() {
  return /** @type{?proto.dash.v1.LessonUnitBook} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonUnitBook, 1));
};


/**
 * @param {?proto.dash.v1.LessonUnitBook|undefined} value
 * @return {!proto.dash.v1.GetLessonUnitBookResponse} returns this
*/
proto.dash.v1.GetLessonUnitBookResponse.prototype.setLessonUnitBook = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.GetLessonUnitBookResponse} returns this
 */
proto.dash.v1.GetLessonUnitBookResponse.prototype.clearLessonUnitBook = function() {
  return this.setLessonUnitBook(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.GetLessonUnitBookResponse.prototype.hasLessonUnitBook = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.dash.v1.PutLessonUnitBookRequest.oneofGroups_ = [[2,3,4]];

/**
 * @enum {number}
 */
proto.dash.v1.PutLessonUnitBookRequest.ContentCase = {
  CONTENT_NOT_SET: 0,
  TARGET_URL: 2,
  FILE: 3,
  SPLIT_BOOK: 4
};

/**
 * @return {proto.dash.v1.PutLessonUnitBookRequest.ContentCase}
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.getContentCase = function() {
  return /** @type {proto.dash.v1.PutLessonUnitBookRequest.ContentCase} */(jspb.Message.computeOneofCase(this, proto.dash.v1.PutLessonUnitBookRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.PutLessonUnitBookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.PutLessonUnitBookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitBookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnitBook: (f = msg.getLessonUnitBook()) && dash_v1_models_pb.LessonUnitBook.toObject(includeInstance, f),
    targetUrl: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    file: (f = msg.getFile()) && dash_v1_models_pb.File.toObject(includeInstance, f),
    splitBook: (f = msg.getSplitBook()) && dash_v1_models_pb.SplitBook.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.PutLessonUnitBookRequest}
 */
proto.dash.v1.PutLessonUnitBookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.PutLessonUnitBookRequest;
  return proto.dash.v1.PutLessonUnitBookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.PutLessonUnitBookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.PutLessonUnitBookRequest}
 */
proto.dash.v1.PutLessonUnitBookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnitBook;
      reader.readMessage(value,dash_v1_models_pb.LessonUnitBook.deserializeBinaryFromReader);
      msg.setLessonUnitBook(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTargetUrl(value);
      break;
    case 3:
      var value = new dash_v1_models_pb.File;
      reader.readMessage(value,dash_v1_models_pb.File.deserializeBinaryFromReader);
      msg.setFile(value);
      break;
    case 4:
      var value = new dash_v1_models_pb.SplitBook;
      reader.readMessage(value,dash_v1_models_pb.SplitBook.deserializeBinaryFromReader);
      msg.setSplitBook(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.PutLessonUnitBookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.PutLessonUnitBookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitBookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnitBook();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnitBook.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getFile();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      dash_v1_models_pb.File.serializeBinaryToWriter
    );
  }
  f = message.getSplitBook();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      dash_v1_models_pb.SplitBook.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonUnitBook lesson_unit_book = 1;
 * @return {?proto.dash.v1.LessonUnitBook}
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.getLessonUnitBook = function() {
  return /** @type{?proto.dash.v1.LessonUnitBook} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonUnitBook, 1));
};


/**
 * @param {?proto.dash.v1.LessonUnitBook|undefined} value
 * @return {!proto.dash.v1.PutLessonUnitBookRequest} returns this
*/
proto.dash.v1.PutLessonUnitBookRequest.prototype.setLessonUnitBook = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.PutLessonUnitBookRequest} returns this
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.clearLessonUnitBook = function() {
  return this.setLessonUnitBook(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.hasLessonUnitBook = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool target_url = 2;
 * @return {boolean}
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.getTargetUrl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dash.v1.PutLessonUnitBookRequest} returns this
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.setTargetUrl = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.dash.v1.PutLessonUnitBookRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.dash.v1.PutLessonUnitBookRequest} returns this
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.clearTargetUrl = function() {
  return jspb.Message.setOneofField(this, 2, proto.dash.v1.PutLessonUnitBookRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.hasTargetUrl = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional File file = 3;
 * @return {?proto.dash.v1.File}
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.getFile = function() {
  return /** @type{?proto.dash.v1.File} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.File, 3));
};


/**
 * @param {?proto.dash.v1.File|undefined} value
 * @return {!proto.dash.v1.PutLessonUnitBookRequest} returns this
*/
proto.dash.v1.PutLessonUnitBookRequest.prototype.setFile = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.dash.v1.PutLessonUnitBookRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.PutLessonUnitBookRequest} returns this
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.clearFile = function() {
  return this.setFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.hasFile = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SplitBook split_book = 4;
 * @return {?proto.dash.v1.SplitBook}
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.getSplitBook = function() {
  return /** @type{?proto.dash.v1.SplitBook} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.SplitBook, 4));
};


/**
 * @param {?proto.dash.v1.SplitBook|undefined} value
 * @return {!proto.dash.v1.PutLessonUnitBookRequest} returns this
*/
proto.dash.v1.PutLessonUnitBookRequest.prototype.setSplitBook = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.dash.v1.PutLessonUnitBookRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.PutLessonUnitBookRequest} returns this
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.clearSplitBook = function() {
  return this.setSplitBook(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonUnitBookRequest.prototype.hasSplitBook = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.PutLessonUnitBookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.PutLessonUnitBookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.PutLessonUnitBookResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitBookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnitBook: (f = msg.getLessonUnitBook()) && dash_v1_models_pb.LessonUnitBook.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.PutLessonUnitBookResponse}
 */
proto.dash.v1.PutLessonUnitBookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.PutLessonUnitBookResponse;
  return proto.dash.v1.PutLessonUnitBookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.PutLessonUnitBookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.PutLessonUnitBookResponse}
 */
proto.dash.v1.PutLessonUnitBookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnitBook;
      reader.readMessage(value,dash_v1_models_pb.LessonUnitBook.deserializeBinaryFromReader);
      msg.setLessonUnitBook(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.PutLessonUnitBookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.PutLessonUnitBookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.PutLessonUnitBookResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitBookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnitBook();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnitBook.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonUnitBook lesson_unit_book = 1;
 * @return {?proto.dash.v1.LessonUnitBook}
 */
proto.dash.v1.PutLessonUnitBookResponse.prototype.getLessonUnitBook = function() {
  return /** @type{?proto.dash.v1.LessonUnitBook} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonUnitBook, 1));
};


/**
 * @param {?proto.dash.v1.LessonUnitBook|undefined} value
 * @return {!proto.dash.v1.PutLessonUnitBookResponse} returns this
*/
proto.dash.v1.PutLessonUnitBookResponse.prototype.setLessonUnitBook = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.PutLessonUnitBookResponse} returns this
 */
proto.dash.v1.PutLessonUnitBookResponse.prototype.clearLessonUnitBook = function() {
  return this.setLessonUnitBook(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonUnitBookResponse.prototype.hasLessonUnitBook = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.ListLessonUnitBooksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.ListLessonUnitBooksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.ListLessonUnitBooksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitBooksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    areaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    lessonId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.ListLessonUnitBooksRequest}
 */
proto.dash.v1.ListLessonUnitBooksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.ListLessonUnitBooksRequest;
  return proto.dash.v1.ListLessonUnitBooksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.ListLessonUnitBooksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.ListLessonUnitBooksRequest}
 */
proto.dash.v1.ListLessonUnitBooksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAreaId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLessonId(value);
      break;
    case 3:
      var value = /** @type {!proto.types.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.ListLessonUnitBooksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.ListLessonUnitBooksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.ListLessonUnitBooksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitBooksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLessonId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 area_id = 1;
 * @return {number}
 */
proto.dash.v1.ListLessonUnitBooksRequest.prototype.getAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.v1.ListLessonUnitBooksRequest} returns this
 */
proto.dash.v1.ListLessonUnitBooksRequest.prototype.setAreaId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 lesson_id = 2;
 * @return {number}
 */
proto.dash.v1.ListLessonUnitBooksRequest.prototype.getLessonId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.v1.ListLessonUnitBooksRequest} returns this
 */
proto.dash.v1.ListLessonUnitBooksRequest.prototype.setLessonId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional types.v1.Status status = 3;
 * @return {!proto.types.v1.Status}
 */
proto.dash.v1.ListLessonUnitBooksRequest.prototype.getStatus = function() {
  return /** @type {!proto.types.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.types.v1.Status} value
 * @return {!proto.dash.v1.ListLessonUnitBooksRequest} returns this
 */
proto.dash.v1.ListLessonUnitBooksRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dash.v1.ListLessonUnitBooksResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.ListLessonUnitBooksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.ListLessonUnitBooksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.ListLessonUnitBooksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitBooksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnitBooksList: jspb.Message.toObjectList(msg.getLessonUnitBooksList(),
    dash_v1_models_pb.LessonUnitBook.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.ListLessonUnitBooksResponse}
 */
proto.dash.v1.ListLessonUnitBooksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.ListLessonUnitBooksResponse;
  return proto.dash.v1.ListLessonUnitBooksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.ListLessonUnitBooksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.ListLessonUnitBooksResponse}
 */
proto.dash.v1.ListLessonUnitBooksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnitBook;
      reader.readMessage(value,dash_v1_models_pb.LessonUnitBook.deserializeBinaryFromReader);
      msg.addLessonUnitBooks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.ListLessonUnitBooksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.ListLessonUnitBooksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.ListLessonUnitBooksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitBooksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnitBooksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnitBook.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LessonUnitBook lesson_unit_books = 1;
 * @return {!Array<!proto.dash.v1.LessonUnitBook>}
 */
proto.dash.v1.ListLessonUnitBooksResponse.prototype.getLessonUnitBooksList = function() {
  return /** @type{!Array<!proto.dash.v1.LessonUnitBook>} */ (
    jspb.Message.getRepeatedWrapperField(this, dash_v1_models_pb.LessonUnitBook, 1));
};


/**
 * @param {!Array<!proto.dash.v1.LessonUnitBook>} value
 * @return {!proto.dash.v1.ListLessonUnitBooksResponse} returns this
*/
proto.dash.v1.ListLessonUnitBooksResponse.prototype.setLessonUnitBooksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.dash.v1.LessonUnitBook=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dash.v1.LessonUnitBook}
 */
proto.dash.v1.ListLessonUnitBooksResponse.prototype.addLessonUnitBooks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.dash.v1.LessonUnitBook, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dash.v1.ListLessonUnitBooksResponse} returns this
 */
proto.dash.v1.ListLessonUnitBooksResponse.prototype.clearLessonUnitBooksList = function() {
  return this.setLessonUnitBooksList([]);
};


goog.object.extend(exports, proto.dash.v1);
